// Shared confirm dialog for the demo reset. Presentational only — it is driven
// by the useDemoReset() state machine and rendered by any surface that offers
// the reset (topbar, Help Center). Copy is passed in from useDemoReset() so
// shared-demo and private-sandbox environments stay in lockstep.

export function DemoResetConfirm({ open, resetting, onCancel, onConfirm, copy }) {
  if (!open) return null;
  return (
    <div
      className="drawer-backdrop open"
      onClick={() => !resetting && onCancel()}
      role="dialog"
      aria-modal="true"
      aria-label={copy.ariaLabel}
    >
      <div
        className="confirm-modal glass-panel"
        onClick={(e) => e.stopPropagation()}
        data-testid="demo-reset-confirm"
        aria-busy={resetting ? 'true' : 'false'}
      >
        <h3>{resetting ? copy.restoringTitle : copy.confirmTitle}</h3>
        <p>{resetting ? copy.restoringBody : copy.confirmBody}</p>
        <div className="row" style={{ gap: 8, justifyContent: 'flex-end' }}>
          <button className="btn ghost" onClick={onCancel} disabled={resetting}>
            Cancel
          </button>
          <button
            className="btn destructive"
            onClick={onConfirm}
            disabled={resetting}
            data-testid="demo-reset-confirm-go"
          >
            {resetting ? copy.restoringGo : copy.confirmGo}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DemoResetConfirm;
